import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Checkbox from "@mui/material/Checkbox";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";

import {
  setCredentialManagementShareSelectedUsers,
  setCredentialManagementUnshareSelectedUsers,
  clearCredentialsManagementShareSelectedUsers
} from "redux/actions/portal/credentialManagementActionCreator";

const CredentialManagementSelectAll = ({ onSearchChange }) => {
  const {
    credentialManangementShareAvailableUsers,
    credentialManagementUnshareAvailableUsers,
    credentialDialogMode,
  } = useSelector((store) => store.portal.credentialManagement);
  const [selectAll, setSelectAll] = useState(false);
  const rDispatch = useDispatch();

  const handleSelectAllUsers = (e) => {
    const { checked } = e.target;

    if (credentialDialogMode === "share") {
      if (checked) {
        setSelectAll(true);
        rDispatch(
          setCredentialManagementShareSelectedUsers(
            credentialManangementShareAvailableUsers.map((user) => ({
              user_id: user.auth0_id,
              share_type: "use",
            }))
          )
        );
      } else {
        setSelectAll(false);
        rDispatch(clearCredentialsManagementShareSelectedUsers());
      }
    }

    if (credentialDialogMode === "unshare") {
      if (checked) {
        setSelectAll(true);
        rDispatch(
          setCredentialManagementUnshareSelectedUsers(
            credentialManagementUnshareAvailableUsers.map((user) => user.auth0_id)
          )
        );
      } else {
        setSelectAll(false);
        rDispatch(setCredentialManagementUnshareSelectedUsers([]));
      }
    }
  };

  return (
    <SoftBox>
      <SoftBox display="flex" alignItems="center" width="100%" gap={2} mb={2}>
        <Checkbox checked={selectAll} onChange={handleSelectAllUsers} />
        <SoftTypography variant="h6">Select All</SoftTypography>
      </SoftBox>
      <SoftBox width={{ xs: "100%" }} maxWidth={{ md: "auto", xl: "370px" }}>
        <SoftInput placeholder={"Search..."} onChange={(e) => onSearchChange(e.target.value)} />
      </SoftBox>
    </SoftBox>
  );
};

export default CredentialManagementSelectAll;
